<template>
  <div id="un_app_container" :class='{off: deactivated && isShopifyEnv}'>
    <div id='un_viewcontainer' class='z_1'>
      <router-view v-if='isGoldEnv' />

      <div v-if='isShopifyEnv'>
        <Introduction :show='showIntroduction' />
        <DesignProduct
          :deactivated='deactivated'
          @activate-customizer='onActivate'
          @deactivate-customizer='onDeactivate' />
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/shared/Head.vue'
import DesignProduct from '@/components/product-designer/DesignProduct.vue'
import Introduction from '@/components/product-designer/Introduction.vue'
import {isGoldEnv, isShopifyEnv} from '$utilities/environment'
import {
  unUi,
  REVEAL_INTRO_EVENT,
  HIDE_INTRO_EVENT
} from '@/components/EventBuses'

export default {
  name: 'App',

  data () {
    return {
      deactivated: true,
      showIntroduction: false
    }
  },

  methods: {
    onDeactivate () {
      this.deactivated = true
      document.body.classList.remove('customizer-activated')
      window.UNCOMMON.destroyCustomizer()
    },

    onActivate () {
      this.deactivated = false
      document.body.classList.add('customizer-activated')
    }
  },

  mounted () {
    unUi.$on(REVEAL_INTRO_EVENT, () => {
      this.showIntroduction = true
    })

    unUi.$on(HIDE_INTRO_EVENT, () => {
      this.showIntroduction = false
    })
  },

  computed: {
    isShopifyEnv,
    isGoldEnv
  },

  components: {
    DesignProduct,
    Head,
    Introduction
  }
}
</script>

<style lang='scss' scoped>
#un_app_container {
  @include full_wh;
  position: fixed;
  z-index: 9999999;
  opacity:1;
  visibility: visible;
  transform: translate3d(0px, 0px, 0px) scale(1);
  transition: all 0.35s ease-in-out;
  background: rgb(255,255,255);

  &.off {
    transform: translate3d(0px, 0px, 0px) scale(1.1);
    opacity:0;
    visibility: 0;
  }
}

#un_viewcontainer {
  position: absolute;
  left:0;
  top: 0;
  width:100%;
  height: 100%;
  padding: $pad_un_viewcontainer_top $pad_un_viewcontainer_sides;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// uncommon-client/App.vue